import {connect} from "react-redux";
import Opportunity from "./Add";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../service/Account/action";
import {saveForBA} from "../../../service/Opportunities/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    saveDetails:state.Opportunitie.saveDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            saveForBA
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Opportunity);
